import { createContext, useContext, useState } from "react";
import { PropTypes } from "prop-types";

export const CriteoBannerContext = createContext({});

export const CriteoBannerProvider = ({ children }) => {
  const [bannerData, setBannerData] = useState(undefined);

  return (
    <CriteoBannerContext.Provider value={{ bannerData, setBannerData }}>
      {children}
    </CriteoBannerContext.Provider>
  );
};

CriteoBannerProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export const useCriteoBanner = () => useContext(CriteoBannerContext);
